import { Link } from 'react-router-dom';
import { FaCheckCircle, FaPhone } from 'react-icons/fa';
import styles from '../styles/pages.module.css';

export default function Nosotros() {
  return (
    <div style={{ background: '#FAF7F2' }}>
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <span className={styles.eyebrow} style={{ color: '#FFB380' }}>Nuestra historia</span>
          <h1>Más de 25 años moviendo hogares</h1>
          <p>Lo que comenzó como una furgoneta y mucha ilusión, hoy es el equipo de confianza de miles de familias madrileñas.</p>
        </div>
      </section>

      <section className={styles.section}>
        <div className={styles.container}>
          <div className={styles.splitGridLeaning} style={{ maxWidth: '1100px', margin: '0 auto 4rem' }}>
            <div>
              <span className={styles.eyebrow}>Quiénes somos</span>
              <h2 style={{ fontSize: '2.2rem', margin: '1rem 0 1.5rem', lineHeight: 1.15 }}>
                Un equipo con raíces en Móstoles
              </h2>
              <p style={{ fontSize: '1.05rem', color: '#4A4A4A', lineHeight: 1.75, marginBottom: '1rem' }}>
                Britosa nació en 1998 con una idea muy sencilla: tratar las cosas de la gente como si fueran nuestras. Desde entonces, hemos acompañado a miles de familias, empresas y emprendedores en su momento más importante.
              </p>
              <p style={{ fontSize: '1.05rem', color: '#4A4A4A', lineHeight: 1.75 }}>
                Hoy somos un equipo propio, formado y asegurado, con vehículos modernos y un método que hemos pulido durante más de dos décadas. Mudanzas locales, nacionales o internacionales: el compromiso es siempre el mismo.
              </p>
            </div>
            <div className={`${styles.splitImage} ${styles.splitImageAspect45}`}>
              <img src="/assets/images/carousel-4.webp" alt="Madrid" />
            </div>
          </div>

          {/* Valores */}
          <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
              <span className={styles.eyebrow}>Nuestros valores</span>
              <h2 style={{ fontSize: '2.2rem', margin: '1rem 0 0' }}>En qué creemos</h2>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '2rem' }}>
              {[
                { title: 'Cuidado', desc: 'Cada caja lleva dentro una historia. Lo tratamos todo como si fuera nuestro.' },
                { title: 'Transparencia', desc: 'Presupuesto cerrado y claro. Sin sorpresas, sin costes ocultos.' },
                { title: 'Compromiso', desc: 'Llegamos a tiempo, cumplimos plazos y resolvemos imprevistos.' },
                { title: 'Cercanía', desc: 'Somos tus vecinos. Conocemos Madrid porque vivimos en Madrid.' }
              ].map((v, i) => (
                <div key={i} style={{
                  background: 'white',
                  padding: '2rem',
                  borderRadius: '1rem',
                  border: '1px solid #EFEAE0'
                }}>
                  <h3 style={{ color: '#D97441', fontSize: '1.25rem', marginBottom: '0.75rem', fontFamily: 'Fraunces, Georgia, serif' }}>
                    {v.title}
                  </h3>
                  <p style={{ color: '#4A4A4A', lineHeight: 1.6, fontSize: '0.95rem' }}>
                    {v.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Razones */}
      <section style={{ padding: '5rem 0', background: 'white' }}>
        <div className={styles.container}>
          <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
            <span className={styles.eyebrow}>Por qué Britosa</span>
            <h2 style={{ fontSize: '2.2rem', margin: '1rem 0 2.5rem' }}>
              Lo que nos hace diferentes
            </h2>

            <ul style={{
              listStyle: 'none',
              padding: 0,
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '1rem',
              textAlign: 'left'
            }}>
              {[
                'Más de 25 años de experiencia',
                'Equipo propio, formado y fijo',
                'Presupuesto cerrado, sin sorpresas',
                'Seguro integral a todo riesgo',
                'Disponibilidad 8:00–22:00 todos los días',
                'Vehículos modernos y revisados',
                'Embalaje profesional incluido',
                'Atención personalizada siempre'
              ].map((item, i) => (
                <li key={i} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  padding: '0.5rem 0',
                  color: '#1A1A1A',
                  fontWeight: 500
                }}>
                  <FaCheckCircle style={{ color: '#D97441', flexShrink: 0 }} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className={styles.finalCta}>
        <div className={styles.container}>
          <div className={styles.finalCtaBox}>
            <h2>¿Hablamos?</h2>
            <p>Pide tu presupuesto o llámanos. Sin compromiso.</p>
            <div className={styles.finalCtaButtons}>
              <Link to="/presupuesto" className={styles.btnPrimary}>
                Pedir presupuesto
              </Link>
              <a href="tel:+34691604880" className={styles.btnGhostDark}>
                <FaPhone /> 691 60 48 80
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
